import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, ref, watchEffect} from "vue";


const __default__ = {
  name: "JTabsContent"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  activeValue: {
    type: [Number, String],
    required: true
  },

  value: {
    type: [Number, String],
    required: true
  }
},
  setup(__props) {

const props = __props




const rendered = ref<boolean>(false)
watchEffect(() => {
  if (props.activeValue === props.value) {
    rendered.value = true
  }
})

// 如果已经渲染过就不要去除
const vif = computed(() => {
  if (rendered.value || props.activeValue === props.value) {
    return true
  }
  return false
})

const vshow = computed(() => {
  return props.activeValue === props.value
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_unref(vif))
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _unref(vshow)]
  ])
}
}

})